import React, { forwardRef } from 'react'
import { Input } from './style'

const Text = forwardRef(({ type, ...props }, ref) => <Input ref={ref} type={type || 'text'} {...props} />)
export default Text
